import React from 'react';
import { SvgIcon } from '@mui/material';

const NotFoundIcon = props => {
  return (
    <SvgIcon
      viewBox="0 0 75 75"
      width="75"
      height="75"
      preserveAspectRatio="xMidYMid meet"
      style={{
        transform: 'translate3d(0px, 0px, 0px)'
      }}
      {...props}
    >
      <defs>
        <clipPath id="__lottie_element_1207">
          <rect width="75" height="75" x="0" y="0" />
        </clipPath>
        <clipPath id="__lottie_element_1209">
          <path d="M0,0 L55,0 L55,64 L0,64z" />
        </clipPath>
        <clipPath id="__lottie_element_1213">
          <path d="M0,0 L55,0 L55,64 L0,64z" />
        </clipPath>
        <mask id="__lottie_element_1216">
          <g
            transform="matrix(1,0,0,1,37.5,37.5)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(255,255,255)"
                fillOpacity="1"
                d=" M6,15 C11.798999786376953,15 16.5,10.298999786376953 16.5,4.5 C16.5,-1.2990000247955322 11.798999786376953,-6 6,-6 C0.20100000500679016,-6 -4.5,-1.2990000247955322 -4.5,4.5 C-4.5,10.298999786376953 0.20100000500679016,15 6,15z"
              />
              <path
                strokeLinecap="butt"
                strokeLinejoin="miter"
                fillOpacity="0"
                strokeMiterlimit="10"
                stroke="rgb(191,201,207)"
                strokeOpacity="1"
                strokeWidth="4"
                d=" M6,15 C11.798999786376953,15 16.5,10.298999786376953 16.5,4.5 C16.5,-1.2990000247955322 11.798999786376953,-6 6,-6 C0.20100000500679016,-6 -4.5,-1.2990000247955322 -4.5,4.5 C-4.5,10.298999786376953 0.20100000500679016,15 6,15z"
              />
            </g>
          </g>
        </mask>
      </defs>
      <g clipPath="url(#__lottie_element_1207)">
        <g
          clipPath="url(#__lottie_element_1209)"
          transform="matrix(1,0,0,1,10,7.5)"
          opacity="0.2"
          style={{ display: ' block' }}
        >
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M17.902999877929688,-32 C17.902999877929688,-32 -26.902999877929688,-32 -26.902999877929688,-32 C-27.232999801635742,-32 -27.5,-31.735000610351562 -27.5,-31.408000946044922 C-27.5,-31.408000946044922 -27.5,-26.1200008392334 -27.5,-26.1200008392334 C-27.5,-26.1200008392334 -27.5,8.407999992370605 -27.5,8.407999992370605 C-27.5,8.734999656677246 -27.232999801635742,9 -26.902999877929688,9 C-26.902999877929688,9 17.902999877929688,9 17.902999877929688,9 C18.232999801635742,9 18.5,8.734999656677246 18.5,8.407999992370605 C18.5,8.407999992370605 18.5,-26.1200008392334 18.5,-26.1200008392334 C18.5,-26.1200008392334 18.5,-31.408000946044922 18.5,-31.408000946044922 C18.5,-31.735000610351562 18.232999801635742,-32 17.902999877929688,-32z M-26.30699920654297,-26.711999893188477 C-26.30699920654297,-26.711999893188477 17.30699920654297,-26.711999893188477 17.30699920654297,-26.711999893188477 C17.30699920654297,-26.711999893188477 17.30699920654297,-30.81599998474121 17.30699920654297,-30.81599998474121 C17.30699920654297,-30.81599998474121 -26.30699920654297,-30.81599998474121 -26.30699920654297,-30.81599998474121 C-26.30699920654297,-30.81599998474121 -26.30699920654297,-26.711999893188477 -26.30699920654297,-26.711999893188477z M-26.30699920654297,7.815999984741211 C-26.30699920654297,7.815999984741211 17.30699920654297,7.815999984741211 17.30699920654297,7.815999984741211 C17.30699920654297,7.815999984741211 17.30699920654297,-25.527999877929688 17.30699920654297,-25.527999877929688 C17.30699920654297,-25.527999877929688 -26.30699920654297,-25.527999877929688 -26.30699920654297,-25.527999877929688 C-26.30699920654297,-25.527999877929688 -26.30699920654297,7.815999984741211 -26.30699920654297,7.815999984741211z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(245,245,245)"
                fillOpacity="1"
                d=" M-16.5,-9 C-12.633999824523926,-9 -9.5,-12.133999824523926 -9.5,-16 C-9.5,-19.865999221801758 -12.633999824523926,-23 -16.5,-23 C-20.365999221801758,-23 -23.5,-19.865999221801758 -23.5,-16 C-23.5,-12.133999824523926 -20.365999221801758,-9 -16.5,-9z"
              />
              <path
                strokeLinecap="butt"
                strokeLinejoin="miter"
                fillOpacity="0"
                strokeMiterlimit="10"
                stroke="rgb(222,227,230)"
                strokeOpacity="1"
                strokeWidth="1"
                d=" M-16.5,-9 C-12.633999824523926,-9 -9.5,-12.133999824523926 -9.5,-16 C-9.5,-19.865999221801758 -12.633999824523926,-23 -16.5,-23 C-20.365999221801758,-23 -23.5,-19.865999221801758 -23.5,-16 C-23.5,-12.133999824523926 -20.365999221801758,-9 -16.5,-9z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(149,163,171)"
                fillOpacity="1"
                d=" M-17.558000564575195,-12.666000366210938 C-17.558000564575195,-12.970000267028809 -17.476999282836914,-13.199999809265137 -17.31399917602539,-13.354999542236328 C-17.150999069213867,-13.510000228881836 -16.915000915527344,-13.588000297546387 -16.604000091552734,-13.588000297546387 C-16.304000854492188,-13.588000297546387 -16.07200050354004,-13.508999824523926 -15.906999588012695,-13.350000381469727 C-15.741999626159668,-13.190999984741211 -15.65999984741211,-12.961999893188477 -15.65999984741211,-12.666000366210938 C-15.65999984741211,-12.380000114440918 -15.743000030517578,-12.156000137329102 -15.909000396728516,-11.991000175476074 C-16.075000762939453,-11.826000213623047 -16.308000564575195,-11.744999885559082 -16.604000091552734,-11.744999885559082 C-16.908000946044922,-11.744999885559082 -17.14299964904785,-11.824999809265137 -17.30900001525879,-11.986000061035156 C-17.475000381469727,-12.147000312805176 -17.558000564575195,-12.373000144958496 -17.558000564575195,-12.666000366210938z M-17.384000778198242,-14.520999908447266 C-17.384000778198242,-14.520999908447266 -17.384000778198242,-14.92199993133545 -17.384000778198242,-14.92199993133545 C-17.384000778198242,-15.269000053405762 -17.309999465942383,-15.571000099182129 -17.16200065612793,-15.82800006866455 C-17.013999938964844,-16.084999084472656 -16.743000030517578,-16.357999801635742 -16.349000930786133,-16.64699935913086 C-15.968999862670898,-16.917999267578125 -15.718999862670898,-17.138999938964844 -15.597999572753906,-17.30900001525879 C-15.47700023651123,-17.479000091552734 -15.416000366210938,-17.667999267578125 -15.416000366210938,-17.878000259399414 C-15.416000366210938,-18.113000869750977 -15.501999855041504,-18.29199981689453 -15.675999641418457,-18.415000915527344 C-15.850000381469727,-18.538000106811523 -16.091999053955078,-18.599000930786133 -16.402999877929688,-18.599000930786133 C-16.94499969482422,-18.599000930786133 -17.56399917602539,-18.422000885009766 -18.257999420166016,-18.06800079345703 C-18.257999420166016,-18.06800079345703 -18.849000930786133,-19.2549991607666 -18.849000930786133,-19.2549991607666 C-18.042999267578125,-19.707000732421875 -17.187999725341797,-19.933000564575195 -16.284000396728516,-19.933000564575195 C-15.538999557495117,-19.933000564575195 -14.946999549865723,-19.753999710083008 -14.508000373840332,-19.395999908447266 C-14.069000244140625,-19.038000106811523 -13.848999977111816,-18.562000274658203 -13.848999977111816,-17.96500015258789 C-13.848999977111816,-17.566999435424805 -13.939000129699707,-17.222999572753906 -14.119999885559082,-16.93400001525879 C-14.300999641418457,-16.645000457763672 -14.644000053405762,-16.31999969482422 -15.149999618530273,-15.958000183105469 C-15.496999740600586,-15.701000213623047 -15.717000007629395,-15.505999565124512 -15.809000015258789,-15.371999740600586 C-15.901000022888184,-15.23799991607666 -15.946999549865723,-15.062999725341797 -15.946999549865723,-14.845999717712402 C-15.946999549865723,-14.845999717712402 -15.946999549865723,-14.520999908447266 -15.946999549865723,-14.520999908447266 C-15.946999549865723,-14.520999908447266 -17.384000778198242,-14.520999908447266 -17.384000778198242,-14.520999908447266z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-3.5,-28 C-3.5,-28 13.5,-28 13.5,-28 C13.5,-28 13.5,-29 13.5,-29 C13.5,-29 -3.5,-29 -3.5,-29 C-3.5,-29 -3.5,-28 -3.5,-28z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-24.5,-28 C-24.5,-28 -23.5,-28 -23.5,-28 C-23.5,-28 -23.5,-29 -23.5,-29 C-23.5,-29 -24.5,-29 -24.5,-29 C-24.5,-29 -24.5,-28 -24.5,-28z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-21.5,-28 C-21.5,-28 -20.5,-28 -20.5,-28 C-20.5,-28 -20.5,-29 -20.5,-29 C-20.5,-29 -21.5,-29 -21.5,-29 C-21.5,-29 -21.5,-28 -21.5,-28z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-18.5,-28 C-18.5,-28 -17.5,-28 -17.5,-28 C-17.5,-28 -17.5,-29 -17.5,-29 C-17.5,-29 -18.5,-29 -18.5,-29 C-18.5,-29 -18.5,-28 -18.5,-28z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-5.9079999923706055,-15 C-5.9079999923706055,-15 -0.09200000017881393,-15 -0.09200000017881393,-15 C0.23499999940395355,-15 0.5,-15.265000343322754 0.5,-15.592000007629395 C0.5,-15.592000007629395 0.5,-21.408000946044922 0.5,-21.408000946044922 C0.5,-21.735000610351562 0.23499999940395355,-22 -0.09200000017881393,-22 C-0.09200000017881393,-22 -5.9079999923706055,-22 -5.9079999923706055,-22 C-6.235000133514404,-22 -6.5,-21.735000610351562 -6.5,-21.408000946044922 C-6.5,-21.408000946044922 -6.5,-15.592000007629395 -6.5,-15.592000007629395 C-6.5,-15.265000343322754 -6.235000133514404,-15 -5.9079999923706055,-15z M-5.316999912261963,-16.183000564575195 C-5.316999912261963,-16.183000564575195 -0.6830000281333923,-16.183000564575195 -0.6830000281333923,-16.183000564575195 C-0.6830000281333923,-16.183000564575195 -0.6830000281333923,-20.816999435424805 -0.6830000281333923,-20.816999435424805 C-0.6830000281333923,-20.816999435424805 -5.316999912261963,-20.816999435424805 -5.316999912261963,-20.816999435424805 C-5.316999912261963,-20.816999435424805 -5.316999912261963,-16.183000564575195 -5.316999912261963,-16.183000564575195z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-23.5,-4 C-23.5,-4 -10.5,-4 -10.5,-4 C-10.5,-4 -10.5,-5 -10.5,-5 C-10.5,-5 -23.5,-5 -23.5,-5 C-23.5,-5 -23.5,-4 -23.5,-4z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,-20 C2.5,-20 14.5,-20 14.5,-20 C14.5,-20 14.5,-21 14.5,-21 C14.5,-21 2.5,-21 2.5,-21 C2.5,-21 2.5,-20 2.5,-20z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,-18 C2.5,-18 8.5,-18 8.5,-18 C8.5,-18 8.5,-19 8.5,-19 C8.5,-19 2.5,-19 2.5,-19 C2.5,-19 2.5,-18 2.5,-18z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-5.9079999923706055,-6 C-5.9079999923706055,-6 -0.09200000017881393,-6 -0.09200000017881393,-6 C0.23499999940395355,-6 0.5,-6.264999866485596 0.5,-6.5920000076293945 C0.5,-6.5920000076293945 0.5,-12.407999992370605 0.5,-12.407999992370605 C0.5,-12.734999656677246 0.23499999940395355,-13 -0.09200000017881393,-13 C-0.09200000017881393,-13 -5.9079999923706055,-13 -5.9079999923706055,-13 C-6.235000133514404,-13 -6.5,-12.734999656677246 -6.5,-12.407999992370605 C-6.5,-12.407999992370605 -6.5,-6.5920000076293945 -6.5,-6.5920000076293945 C-6.5,-6.264999866485596 -6.235000133514404,-6 -5.9079999923706055,-6z M-5.316999912261963,-7.183000087738037 C-5.316999912261963,-7.183000087738037 -0.6830000281333923,-7.183000087738037 -0.6830000281333923,-7.183000087738037 C-0.6830000281333923,-7.183000087738037 -0.6830000281333923,-11.817000389099121 -0.6830000281333923,-11.817000389099121 C-0.6830000281333923,-11.817000389099121 -5.316999912261963,-11.817000389099121 -5.316999912261963,-11.817000389099121 C-5.316999912261963,-11.817000389099121 -5.316999912261963,-7.183000087738037 -5.316999912261963,-7.183000087738037z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,-11 C2.5,-11 14.5,-11 14.5,-11 C14.5,-11 14.5,-12 14.5,-12 C14.5,-12 2.5,-12 2.5,-12 C2.5,-12 2.5,-11 2.5,-11z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,-9 C2.5,-9 11.5,-9 11.5,-9 C11.5,-9 11.5,-10 11.5,-10 C11.5,-10 2.5,-10 2.5,-10 C2.5,-10 2.5,-9 2.5,-9z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-5.9079999923706055,4 C-5.9079999923706055,4 -0.09200000017881393,4 -0.09200000017881393,4 C0.23499999940395355,4 0.5,3.734999895095825 0.5,3.4079999923706055 C0.5,3.4079999923706055 0.5,-2.4079999923706055 0.5,-2.4079999923706055 C0.5,-2.734999895095825 0.23499999940395355,-3 -0.09200000017881393,-3 C-0.09200000017881393,-3 -5.9079999923706055,-3 -5.9079999923706055,-3 C-6.235000133514404,-3 -6.5,-2.734999895095825 -6.5,-2.4079999923706055 C-6.5,-2.4079999923706055 -6.5,3.4079999923706055 -6.5,3.4079999923706055 C-6.5,3.734999895095825 -6.235000133514404,4 -5.9079999923706055,4z M-5.316999912261963,2.816999912261963 C-5.316999912261963,2.816999912261963 -0.6830000281333923,2.816999912261963 -0.6830000281333923,2.816999912261963 C-0.6830000281333923,2.816999912261963 -0.6830000281333923,-1.8170000314712524 -0.6830000281333923,-1.8170000314712524 C-0.6830000281333923,-1.8170000314712524 -5.316999912261963,-1.8170000314712524 -5.316999912261963,-1.8170000314712524 C-5.316999912261963,-1.8170000314712524 -5.316999912261963,2.816999912261963 -5.316999912261963,2.816999912261963z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,-1 C2.5,-1 14.5,-1 14.5,-1 C14.5,-1 14.5,-2 14.5,-2 C14.5,-2 2.5,-2 2.5,-2 C2.5,-2 2.5,-1 2.5,-1z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M2.5,1 C2.5,1 11.5,1 11.5,1 C11.5,1 11.5,0 11.5,0 C11.5,0 2.5,0 2.5,0 C2.5,0 2.5,1 2.5,1z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-23.5,0 C-23.5,0 -10.5,0 -10.5,0 C-10.5,0 -10.5,-1 -10.5,-1 C-10.5,-1 -23.5,-1 -23.5,-1 C-23.5,-1 -23.5,0 -23.5,0z"
              />
            </g>
          </g>
          <g
            transform="matrix(1,0,0,1,27.5,32)"
            opacity="1"
            style={{ display: ' block' }}
          >
            <g opacity="1" transform="matrix(1,0,0,1,0,0)">
              <path
                fillRule="evenodd"
                fill="rgb(222,227,230)"
                fillOpacity="1"
                d=" M-23.5,3 C-23.5,3 -10.5,3 -10.5,3 C-10.5,3 -10.5,2 -10.5,2 C-10.5,2 -23.5,2 -23.5,2 C-23.5,2 -23.5,3 -23.5,3z"
              />
            </g>
          </g>
        </g>
        <g mask="url(#__lottie_element_1216)" style={{ display: ' block' }}>
          <g
            clipPath="url(#__lottie_element_1213)"
            transform="matrix(1.100000023841858,0,0,1.100000023841858,7.25,4.299999237060547)"
            opacity="1"
          >
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M17.902999877929688,-32 C17.902999877929688,-32 -26.902999877929688,-32 -26.902999877929688,-32 C-27.232999801635742,-32 -27.5,-31.735000610351562 -27.5,-31.408000946044922 C-27.5,-31.408000946044922 -27.5,-26.1200008392334 -27.5,-26.1200008392334 C-27.5,-26.1200008392334 -27.5,8.407999992370605 -27.5,8.407999992370605 C-27.5,8.734999656677246 -27.232999801635742,9 -26.902999877929688,9 C-26.902999877929688,9 17.902999877929688,9 17.902999877929688,9 C18.232999801635742,9 18.5,8.734999656677246 18.5,8.407999992370605 C18.5,8.407999992370605 18.5,-26.1200008392334 18.5,-26.1200008392334 C18.5,-26.1200008392334 18.5,-31.408000946044922 18.5,-31.408000946044922 C18.5,-31.735000610351562 18.232999801635742,-32 17.902999877929688,-32z M-26.30699920654297,-26.711999893188477 C-26.30699920654297,-26.711999893188477 17.30699920654297,-26.711999893188477 17.30699920654297,-26.711999893188477 C17.30699920654297,-26.711999893188477 17.30699920654297,-30.81599998474121 17.30699920654297,-30.81599998474121 C17.30699920654297,-30.81599998474121 -26.30699920654297,-30.81599998474121 -26.30699920654297,-30.81599998474121 C-26.30699920654297,-30.81599998474121 -26.30699920654297,-26.711999893188477 -26.30699920654297,-26.711999893188477z M-26.30699920654297,7.815999984741211 C-26.30699920654297,7.815999984741211 17.30699920654297,7.815999984741211 17.30699920654297,7.815999984741211 C17.30699920654297,7.815999984741211 17.30699920654297,-25.527999877929688 17.30699920654297,-25.527999877929688 C17.30699920654297,-25.527999877929688 -26.30699920654297,-25.527999877929688 -26.30699920654297,-25.527999877929688 C-26.30699920654297,-25.527999877929688 -26.30699920654297,7.815999984741211 -26.30699920654297,7.815999984741211z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(245,245,245)"
                  fillOpacity="1"
                  d=" M-16.5,-9 C-12.633999824523926,-9 -9.5,-12.133999824523926 -9.5,-16 C-9.5,-19.865999221801758 -12.633999824523926,-23 -16.5,-23 C-20.365999221801758,-23 -23.5,-19.865999221801758 -23.5,-16 C-23.5,-12.133999824523926 -20.365999221801758,-9 -16.5,-9z"
                />
                <path
                  strokeLinecap="butt"
                  strokeLinejoin="miter"
                  fillOpacity="0"
                  strokeMiterlimit="10"
                  stroke="rgb(222,227,230)"
                  strokeOpacity="1"
                  strokeWidth="1"
                  d=" M-16.5,-9 C-12.633999824523926,-9 -9.5,-12.133999824523926 -9.5,-16 C-9.5,-19.865999221801758 -12.633999824523926,-23 -16.5,-23 C-20.365999221801758,-23 -23.5,-19.865999221801758 -23.5,-16 C-23.5,-12.133999824523926 -20.365999221801758,-9 -16.5,-9z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(149,163,171)"
                  fillOpacity="1"
                  d=" M-17.558000564575195,-12.666000366210938 C-17.558000564575195,-12.970000267028809 -17.476999282836914,-13.199999809265137 -17.31399917602539,-13.354999542236328 C-17.150999069213867,-13.510000228881836 -16.915000915527344,-13.588000297546387 -16.604000091552734,-13.588000297546387 C-16.304000854492188,-13.588000297546387 -16.07200050354004,-13.508999824523926 -15.906999588012695,-13.350000381469727 C-15.741999626159668,-13.190999984741211 -15.65999984741211,-12.961999893188477 -15.65999984741211,-12.666000366210938 C-15.65999984741211,-12.380000114440918 -15.743000030517578,-12.156000137329102 -15.909000396728516,-11.991000175476074 C-16.075000762939453,-11.826000213623047 -16.308000564575195,-11.744999885559082 -16.604000091552734,-11.744999885559082 C-16.908000946044922,-11.744999885559082 -17.14299964904785,-11.824999809265137 -17.30900001525879,-11.986000061035156 C-17.475000381469727,-12.147000312805176 -17.558000564575195,-12.373000144958496 -17.558000564575195,-12.666000366210938z M-17.384000778198242,-14.520999908447266 C-17.384000778198242,-14.520999908447266 -17.384000778198242,-14.92199993133545 -17.384000778198242,-14.92199993133545 C-17.384000778198242,-15.269000053405762 -17.309999465942383,-15.571000099182129 -17.16200065612793,-15.82800006866455 C-17.013999938964844,-16.084999084472656 -16.743000030517578,-16.357999801635742 -16.349000930786133,-16.64699935913086 C-15.968999862670898,-16.917999267578125 -15.718999862670898,-17.138999938964844 -15.597999572753906,-17.30900001525879 C-15.47700023651123,-17.479000091552734 -15.416000366210938,-17.667999267578125 -15.416000366210938,-17.878000259399414 C-15.416000366210938,-18.113000869750977 -15.501999855041504,-18.29199981689453 -15.675999641418457,-18.415000915527344 C-15.850000381469727,-18.538000106811523 -16.091999053955078,-18.599000930786133 -16.402999877929688,-18.599000930786133 C-16.94499969482422,-18.599000930786133 -17.56399917602539,-18.422000885009766 -18.257999420166016,-18.06800079345703 C-18.257999420166016,-18.06800079345703 -18.849000930786133,-19.2549991607666 -18.849000930786133,-19.2549991607666 C-18.042999267578125,-19.707000732421875 -17.187999725341797,-19.933000564575195 -16.284000396728516,-19.933000564575195 C-15.538999557495117,-19.933000564575195 -14.946999549865723,-19.753999710083008 -14.508000373840332,-19.395999908447266 C-14.069000244140625,-19.038000106811523 -13.848999977111816,-18.562000274658203 -13.848999977111816,-17.96500015258789 C-13.848999977111816,-17.566999435424805 -13.939000129699707,-17.222999572753906 -14.119999885559082,-16.93400001525879 C-14.300999641418457,-16.645000457763672 -14.644000053405762,-16.31999969482422 -15.149999618530273,-15.958000183105469 C-15.496999740600586,-15.701000213623047 -15.717000007629395,-15.505999565124512 -15.809000015258789,-15.371999740600586 C-15.901000022888184,-15.23799991607666 -15.946999549865723,-15.062999725341797 -15.946999549865723,-14.845999717712402 C-15.946999549865723,-14.845999717712402 -15.946999549865723,-14.520999908447266 -15.946999549865723,-14.520999908447266 C-15.946999549865723,-14.520999908447266 -17.384000778198242,-14.520999908447266 -17.384000778198242,-14.520999908447266z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-3.5,-28 C-3.5,-28 13.5,-28 13.5,-28 C13.5,-28 13.5,-29 13.5,-29 C13.5,-29 -3.5,-29 -3.5,-29 C-3.5,-29 -3.5,-28 -3.5,-28z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-24.5,-28 C-24.5,-28 -23.5,-28 -23.5,-28 C-23.5,-28 -23.5,-29 -23.5,-29 C-23.5,-29 -24.5,-29 -24.5,-29 C-24.5,-29 -24.5,-28 -24.5,-28z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-21.5,-28 C-21.5,-28 -20.5,-28 -20.5,-28 C-20.5,-28 -20.5,-29 -20.5,-29 C-20.5,-29 -21.5,-29 -21.5,-29 C-21.5,-29 -21.5,-28 -21.5,-28z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-18.5,-28 C-18.5,-28 -17.5,-28 -17.5,-28 C-17.5,-28 -17.5,-29 -17.5,-29 C-17.5,-29 -18.5,-29 -18.5,-29 C-18.5,-29 -18.5,-28 -18.5,-28z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-5.9079999923706055,-15 C-5.9079999923706055,-15 -0.09200000017881393,-15 -0.09200000017881393,-15 C0.23499999940395355,-15 0.5,-15.265000343322754 0.5,-15.592000007629395 C0.5,-15.592000007629395 0.5,-21.408000946044922 0.5,-21.408000946044922 C0.5,-21.735000610351562 0.23499999940395355,-22 -0.09200000017881393,-22 C-0.09200000017881393,-22 -5.9079999923706055,-22 -5.9079999923706055,-22 C-6.235000133514404,-22 -6.5,-21.735000610351562 -6.5,-21.408000946044922 C-6.5,-21.408000946044922 -6.5,-15.592000007629395 -6.5,-15.592000007629395 C-6.5,-15.265000343322754 -6.235000133514404,-15 -5.9079999923706055,-15z M-5.316999912261963,-16.183000564575195 C-5.316999912261963,-16.183000564575195 -0.6830000281333923,-16.183000564575195 -0.6830000281333923,-16.183000564575195 C-0.6830000281333923,-16.183000564575195 -0.6830000281333923,-20.816999435424805 -0.6830000281333923,-20.816999435424805 C-0.6830000281333923,-20.816999435424805 -5.316999912261963,-20.816999435424805 -5.316999912261963,-20.816999435424805 C-5.316999912261963,-20.816999435424805 -5.316999912261963,-16.183000564575195 -5.316999912261963,-16.183000564575195z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-23.5,-4 C-23.5,-4 -10.5,-4 -10.5,-4 C-10.5,-4 -10.5,-5 -10.5,-5 C-10.5,-5 -23.5,-5 -23.5,-5 C-23.5,-5 -23.5,-4 -23.5,-4z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,-20 C2.5,-20 14.5,-20 14.5,-20 C14.5,-20 14.5,-21 14.5,-21 C14.5,-21 2.5,-21 2.5,-21 C2.5,-21 2.5,-20 2.5,-20z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,-18 C2.5,-18 8.5,-18 8.5,-18 C8.5,-18 8.5,-19 8.5,-19 C8.5,-19 2.5,-19 2.5,-19 C2.5,-19 2.5,-18 2.5,-18z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-5.9079999923706055,-6 C-5.9079999923706055,-6 -0.09200000017881393,-6 -0.09200000017881393,-6 C0.23499999940395355,-6 0.5,-6.264999866485596 0.5,-6.5920000076293945 C0.5,-6.5920000076293945 0.5,-12.407999992370605 0.5,-12.407999992370605 C0.5,-12.734999656677246 0.23499999940395355,-13 -0.09200000017881393,-13 C-0.09200000017881393,-13 -5.9079999923706055,-13 -5.9079999923706055,-13 C-6.235000133514404,-13 -6.5,-12.734999656677246 -6.5,-12.407999992370605 C-6.5,-12.407999992370605 -6.5,-6.5920000076293945 -6.5,-6.5920000076293945 C-6.5,-6.264999866485596 -6.235000133514404,-6 -5.9079999923706055,-6z M-5.316999912261963,-7.183000087738037 C-5.316999912261963,-7.183000087738037 -0.6830000281333923,-7.183000087738037 -0.6830000281333923,-7.183000087738037 C-0.6830000281333923,-7.183000087738037 -0.6830000281333923,-11.817000389099121 -0.6830000281333923,-11.817000389099121 C-0.6830000281333923,-11.817000389099121 -5.316999912261963,-11.817000389099121 -5.316999912261963,-11.817000389099121 C-5.316999912261963,-11.817000389099121 -5.316999912261963,-7.183000087738037 -5.316999912261963,-7.183000087738037z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,-11 C2.5,-11 14.5,-11 14.5,-11 C14.5,-11 14.5,-12 14.5,-12 C14.5,-12 2.5,-12 2.5,-12 C2.5,-12 2.5,-11 2.5,-11z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,-9 C2.5,-9 11.5,-9 11.5,-9 C11.5,-9 11.5,-10 11.5,-10 C11.5,-10 2.5,-10 2.5,-10 C2.5,-10 2.5,-9 2.5,-9z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-5.9079999923706055,4 C-5.9079999923706055,4 -0.09200000017881393,4 -0.09200000017881393,4 C0.23499999940395355,4 0.5,3.734999895095825 0.5,3.4079999923706055 C0.5,3.4079999923706055 0.5,-2.4079999923706055 0.5,-2.4079999923706055 C0.5,-2.734999895095825 0.23499999940395355,-3 -0.09200000017881393,-3 C-0.09200000017881393,-3 -5.9079999923706055,-3 -5.9079999923706055,-3 C-6.235000133514404,-3 -6.5,-2.734999895095825 -6.5,-2.4079999923706055 C-6.5,-2.4079999923706055 -6.5,3.4079999923706055 -6.5,3.4079999923706055 C-6.5,3.734999895095825 -6.235000133514404,4 -5.9079999923706055,4z M-5.316999912261963,2.816999912261963 C-5.316999912261963,2.816999912261963 -0.6830000281333923,2.816999912261963 -0.6830000281333923,2.816999912261963 C-0.6830000281333923,2.816999912261963 -0.6830000281333923,-1.8170000314712524 -0.6830000281333923,-1.8170000314712524 C-0.6830000281333923,-1.8170000314712524 -5.316999912261963,-1.8170000314712524 -5.316999912261963,-1.8170000314712524 C-5.316999912261963,-1.8170000314712524 -5.316999912261963,2.816999912261963 -5.316999912261963,2.816999912261963z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,-1 C2.5,-1 14.5,-1 14.5,-1 C14.5,-1 14.5,-2 14.5,-2 C14.5,-2 2.5,-2 2.5,-2 C2.5,-2 2.5,-1 2.5,-1z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M2.5,1 C2.5,1 11.5,1 11.5,1 C11.5,1 11.5,0 11.5,0 C11.5,0 2.5,0 2.5,0 C2.5,0 2.5,1 2.5,1z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-23.5,0 C-23.5,0 -10.5,0 -10.5,0 C-10.5,0 -10.5,-1 -10.5,-1 C-10.5,-1 -23.5,-1 -23.5,-1 C-23.5,-1 -23.5,0 -23.5,0z"
                />
              </g>
            </g>
            <g
              transform="matrix(1,0,0,1,27.5,32)"
              opacity="1"
              style={{ display: ' block' }}
            >
              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                <path
                  fillRule="evenodd"
                  fill="rgb(222,227,230)"
                  fillOpacity="1"
                  d=" M-23.5,3 C-23.5,3 -10.5,3 -10.5,3 C-10.5,3 -10.5,2 -10.5,2 C-10.5,2 -23.5,2 -23.5,2 C-23.5,2 -23.5,3 -23.5,3z"
                />
              </g>
            </g>
          </g>
        </g>
        <g
          transform="matrix(1,0,0,1,37.5,37.5)"
          opacity="1"
          style={{ display: ' block' }}
        >
          <g
            opacity="1"
            transform="matrix(1.3070399761199951,0,0,1.3070399761199951,-1.8422398567199707,-1.3816800117492676)"
          >
            <path
              strokeLinecap="butt"
              strokeLinejoin="miter"
              fillOpacity="0"
              strokeMiterlimit="10"
              stroke="rgb(191,201,207)"
              strokeOpacity="1"
              strokeWidth="2"
              d=" M6,15 C11.798999786376953,15 16.5,10.298999786376953 16.5,4.5 C16.5,-1.2990000247955322 11.798999786376953,-6 6,-6 C0.20100000500679016,-6 -4.5,-1.2990000247955322 -4.5,4.5 C-4.5,10.298999786376953 0.20100000500679016,15 6,15z"
            />
          </g>
        </g>
        <g
          transform="matrix(1,0,0,1,38.60600280761719,38.887001037597656)"
          opacity="1"
          style={{ display: ' block' }}
        >
          <g opacity="1" transform="matrix(1,0,0,1,0,0)">
            <path
              strokeLinecap="round"
              strokeLinejoin="miter"
              fillOpacity="0"
              strokeMiterlimit="10"
              stroke="rgb(191,201,207)"
              strokeOpacity="1"
              strokeWidth="7"
              d=" M14.5,16 C14.5,16 23.5,28 23.5,28"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default NotFoundIcon;
